/* unplugin-vue-components disabled */import { render } from "./UserDesc.vue?vue&type=template&id=6b30fad4&scoped=true"
import script from "./UserDesc.vue?vue&type=script&lang=js"
export * from "./UserDesc.vue?vue&type=script&lang=js"

import "./UserDesc.vue?vue&type=style&index=0&id=6b30fad4&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b30fad4"]])

export default __exports__